<div class="container my-5">
    
    <input (keyup)="search($event)"  class="form-control my-5 w-75 m-auto" type="search" placeholder="Search" aria-label="Search"  >

    <div class="row my-5" >
        
        <div *ngFor="let x of movies" class="col-md-3 my-3">
            <div class="onemovie" [routerLink]="['/moviedetails',x.id]">
    
                <img [src]="imgPrefix + x.poster_path"  class="w-100" alt="">
                <h5 class="my-2">{{x.title}} {{x.name}}</h5>
    
    
            </div>
    
        </div>
    
    </div>
    
    
    
    
    <div class="row justify-content-center">
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',1]"  (click)="test($event)" >1</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',2]"  (click)="test($event)" >2</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',3]"  (click)="test($event)">3</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',4]"  (click)="test($event)">4</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',5]"  (click)="test($event)">5</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',6]"  (click)="test($event)">6</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',7]" (click)="test($event)" >7</div>
        <div class="btn  btn-primary mx-2  demo " [routerLink]="['/home',8]" (click)="test($event)" >8</div>
    
    
    
    </div>
    
    
    
    
    
    
    
        
    
</div>